import { getOidcAuthKey } from "../../../../src/utils/oidcConfig";

export const editorSiteOidc = {
  client_id: process.env.REACT_APP_AUTHENTICATION_CLIENT_ID,
  scope: "openid email profile force-consent allow-u13-login roles",
  brand: "editor",
  allowStudentScope: false,
};

export const editorOidcAuthKey = getOidcAuthKey(editorSiteOidc.client_id);
